import { useState, useCallback } from 'react';
import styled from 'styled-components';
import { Title, Paragrafo, Sectionpd} from "../componentes/padroes";
import '../pages/home.css'
import CarroselClientes from '../componentes/carrosel';
import CarrosselMultiplo from '../componentes/conhecimentos';
import { Helmet } from 'react-helmet';
import JsonWindow from '../componentes/jsonwindows';
import BgBanner from '../componentes/bgbanner';
import CertificadoModal from '../componentes/certificadomodal';

const Bannerao = styled.section`
    padding: 50px 0 0;
    background-color: #2A2A2A;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    position: relative;
    @media (min-width: 996px) {
        padding: 40px 0 20px;
        min-height: 100vh;
    }

    &:before {
        content: "";
        inset: 0;
        position: absolute;
        background: linear-gradient(182deg,rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 1) 100%);
    }
`

const Certificadosbtn = styled.a`
    display:flex;
    flex-direction: column;
    justify-content: space-between;
    color: #fff;
    text-decoration: none;
    transition: 0.5s linear;
    padding: 10px 0;
    & span{
        font-weight: 300;
        text-transform: uppercase;
    }
    & span b{
        font-weight: 600;
    }
    &:hover{
        color: #CD0FE8;
    }
    @media (min-width: 996px) {
        padding: 20px 0;
        flex-direction: row;
    }
`

const Titlecargo = styled.h3`
    display: inline-flex;
    font-size: 18px;
    font-weight: 300;
    grid-gap: 5px;
    & b {
        font-weight: 900;
    }

    @media (min-width: 996px) {
        font-size: 16px;
    }

    @media (min-width: 1280px) {
        font-size: 20px;
    }
`

const Single_exp = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    padding: 30px 0;
    margin-bottom: 20px;
    border-bottom: 1px solid;
    @media (min-width: 996px) {
        flex-direction: row;
        padding: 40px 0;
        justify-content: space-between;
    }
    &:last-child {
        border-bottom: 0px solid;
    }
`

// arquivo: abre no modal (fica em public/certificados) | link: abre em nova aba
const certificados = [
    { titulo: 'Pós-Graduação Lato Sensu - Offensive Cyber Security - Red Team Operations', instituicao: 'FIAP', arquivo: '/certificados/fiap-pos-graduacao.jpg' },
    { titulo: 'Fase 3 a 5 - Penetration Testing, Exploitation e Red Team Ops', instituicao: 'FIAP', arquivo: '/certificados/fiap-fases-3-a-5.jpg' },
    { titulo: 'Fase 2 - Start Point', instituicao: 'FIAP', arquivo: '/certificados/fiap-fase-2.jpg' },
    { titulo: 'Fase 1 - Welcome To Cyber World', instituicao: 'FIAP', link: 'https://drive.google.com/file/d/19KR9aJsulmkVXzbyiHnJ6aWIio0zOe2R/view?usp=sharing' },
    { titulo: 'ANÁLISE E DESENVOLVIMENTO DE SISTEMAS', instituicao: 'UNIVERSIDADE CRUZEIRO DO SUL', arquivo: '/certificados/ads-cruzeiro-do-sul.pdf' },
    { titulo: 'AI-900 -  Implantação de serviços de inteligência artificial em nuvem', instituicao: 'SENAI' },
    { titulo: 'SC-900 - Fundamentos de segurança em Nuvem', instituicao: 'SENAI', link: 'https://drive.google.com/file/d/1bpDO8DKBB9bOJkPt9oPRZwuDqiTxrbL-/view?usp=sharing' },
    { titulo: 'Power BI', instituicao: 'SENAI' },
    { titulo: 'Habilitação Profissional Técnica em Informática', instituicao: 'SENAC' },
    { titulo: 'Qualificação Profissional de Assistente de Desenvolvimento de Aplicativos Computacionais', instituicao: 'SENAC' },
    { titulo: 'Assistente de Suporte e Manutenção de Computadores', instituicao: 'SENAC' },
    { titulo: 'IT Essentials', instituicao: 'CISCO NETWORKING ACADEMY', link: 'https://origamid.com/certificate/2ac4d7ba' },
    { titulo: 'Wordpress como CMS', instituicao: 'ORIGAMID', link: 'https://origamid.com/certificate/2ac4d7ba' },
];

function Home() {
    const [certificadoAberto, setCertificadoAberto] = useState(null);
    const fecharCertificado = useCallback(() => setCertificadoAberto(null), []);

    return (
      <main>
        <Helmet>
            <title>Gabriel Barbosa | Desenvolvedor Web Pleno</title>
            <meta name="description" content="Gabriel Barbosa, desenvolvedor web pleno em Guarulhos-SP. Front-end com React, JavaScript e PHP, integrações de APIs e pós em Offensive Cyber Security pela FIAP." />
            <meta property="og:title" content="Gabriel Barbosa | Desenvolvedor Web Pleno" />
            <meta property="og:description" content="Gabriel Barbosa, desenvolvedor web pleno em Guarulhos-SP. Front-end com React, JavaScript e PHP, integrações de APIs e pós em Offensive Cyber Security pela FIAP." />
        </Helmet>
        <Bannerao className="banner-com-video">
        <BgBanner />

        <div className='container'>
            <h1 className='visually-hidden'>Gabriel Barbosa – Desenvolvedor Web Pleno</h1>
            <div className='row justify-content-lg-center'>
                <div className='col-12 col-lg-9'>
                    <JsonWindow />
                </div>
            </div>
        </div>
        </Bannerao>
        <Sectionpd>
            <div className='container'>
                <div className='row'>
                    <div className='col-12 text-center'>
                        <Title className='mb-lg-5'>PROJETOS</Title>
                    </div>
                </div>
            </div>
            <CarroselClientes />
        </Sectionpd>
        <Sectionpd className='bfexp' style={{background: "white"}}>
            <div className="container">
                <div className="row">
                    <div className='col-12'>
                        <Title className="mb-lg-5 pb-lg-5" style={{color: "#000"}}>EXPERIÊNCIA</Title>
                        <div className='exp__work'>
                            <Single_exp>
                                <div className='cargo'>
                                    <Titlecargo><b>DESENVOLVEDOR</b> <span> //</span> PLENO</Titlecargo>
                                </div>
                                <div className='desc_work ps-0 ps-lg-2'>
                                    <p>Desenvolvimento de interfaces responsivas, Criação de Layouts no FIGMA, Criação de APIs, criação e gerenciamento de bancos de dados, deploy e testes.</p>
                                </div>
                                <div className='local__work d-flex flex-column'>
                                    <span><strong>Grupo ICOM</strong></span>
                                    <span>SET2025_Atualmente</span>
                                </div>
                            </Single_exp>
                            <Single_exp>
                                <div className='cargo'>
                                    <Titlecargo><b>DESENVOLVEDOR</b> <span> //</span> JR.</Titlecargo>
                                </div>
                                <div className='desc_work'>
                                    <p>Desenvolvimento de interfaces, integrações com APIs externas, criação e gerenciamento de bancos de dados, implementação de backups e estratégias de recuperação, monitoramento e análise de logs, suporte na configuração de servidores, configuração e gerenciamento de pipelines, criação e implementação de scripts de automação, deploy e testes.</p>
                                </div>
                                <div className='local__work d-flex flex-column'>
                                    <span><strong>CRT Comunicação</strong></span>
                                    <span>DEZ2023_MAI2025</span>
                                </div>
                            </Single_exp>
                            <Single_exp>
                                <div className='cargo'>
                                    <Titlecargo><b>DESENVOLVEDOR</b> <span> //</span> ASSISTENTE.</Titlecargo>
                                </div>
                                <div className='desc_work'>
                                    <p>Criação de sites, LPs e interfaces, configuração e manutenção de servidores de hospedagem, gerenciamento de backup, captura de dados para integração automática, manutenção de sites e plugins, suporte técnico, administração de plataformas de e-mail marketing, implementação de tags de segmentação para tráfego pago.</p>
                                </div>
                                <div className='local__work d-flex flex-column'>
                                    <span><strong>Agência Decsigner</strong></span>
                                    <span>FEV2021_SET2023</span>
                                </div>
                            </Single_exp>
                        </div>
                    </div>
                </div>
            </div>
        </Sectionpd>
        <Sectionpd>
            <div className='container'>
                <div className='row justify-content-lg-between'>
                    <div className='col-12 col-lg-6 align-content-lg-center'>
                        <div>
                            <Title>CONHECIMENTOS</Title>
                            <Paragrafo>Domínio em HTML, CSS, PHP, JavaScript, usando JQuery, React, TypeScript, Node.js e EJS, conhecimentos em Python, conhecimento sólido em MySQL e SQL para manipulação de dados, e experiência com Microsoft Azure para soluções em nuvem.</Paragrafo>
                        </div>
                    </div>
                    <div className='col-12 col-lg-5'>
                        <div className='carrosels__logos'>
                            <CarrosselMultiplo />
                        </div>
                    </div>
                </div>
            </div>
        </Sectionpd>
        <Sectionpd>
            <div className='container'>
                <div className='row'>
                    <div className='col-12'>
                        <Title>CERTIFICADOS</Title>
                        <div className='certificados__all mt-3 mt-lg-5'>
                            <div className='single_certificado'>
                                {certificados.map((c) => {
                                    const conteudo = <><span>{c.titulo}</span> <span><b>{c.instituicao}</b></span></>;
                                    if (c.arquivo) {
                                        return (
                                            <Certificadosbtn key={c.titulo} href={c.arquivo} onClick={(e) => { e.preventDefault(); setCertificadoAberto(c); }}>
                                                {conteudo}
                                            </Certificadosbtn>
                                        );
                                    }
                                    if (c.link) {
                                        return (
                                            <Certificadosbtn key={c.titulo} href={c.link} target="_blank" rel="noreferrer">
                                                {conteudo}
                                            </Certificadosbtn>
                                        );
                                    }
                                    return <Certificadosbtn as="div" key={c.titulo}>{conteudo}</Certificadosbtn>;
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Sectionpd>
        <CertificadoModal certificado={certificadoAberto} onClose={fecharCertificado} />
      </main>
    );
  }
  
  export default Home;
  